import React, { useState } from 'react';
import './packages.css';
import { FaChevronDown, FaChevronUp, FaBus, FaBinoculars, FaHandsHelping, FaMapMarkedAlt, FaWater, FaTree, FaHome } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import useScrollToTop from './ScrollToTop';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  pauseOnHover: true,
  fade: true,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 768,
      settings: { slidesToShow: 1, slidesToScroll: 1, fade: true }
    }
  ]
};

const itineraryIcons = [
  <FaBus />,
  <FaBinoculars />,
  <FaBinoculars />,
  <FaHome />,
  <FaWater />,
  <FaTree />
];

const itineraryImages = [
  "/images/welcome.jpg",
  "/images/wildbeasts.jpg",
  "/images/view.JPG",
  "/images/volunteerservice.jpg",
  "/images/lakenaivasha.jpeg",
  "/images/gira.jpg"
];

const DayAccordion = ({ item, isOpen, onClick }) => (
  <div className={`day-accordion${isOpen ? ' open' : ''}`}>
    <div className="day-header" onClick={onClick}>
      <h3>{item.icon} {item.day}</h3>
      <span className="toggle-icon">
        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </span>
    </div>

    {isOpen && (
      <div className="day-content-row">
        {/* LEFT CONTENT */}
        <div className="day-text-content">
          <p className="highlight">{item.highlight}</p>
          <div className="details">
            {item.details.map((d, i) => <p key={i}>{d}</p>)}
          </div>
        </div>

        {/* RIGHT IMAGE */}
        {item.image && (
          <div className="day-image-container">
            <img src={item.image} alt={item.day} className="day-image" />
          </div>
        )}
      </div>
    )}
  </div>
);

const Packagemara = () => {
  const [openDay, setOpenDay] = useState(null);
  const toggle = idx => setOpenDay(openDay === idx ? null : idx);
  const [activeTab, setActiveTab] = useState("inclusions");

  const { t } = useTranslation('packagemara');
  useScrollToTop();

  const itineraryData = t("itinerarySection.days", { returnObjects: true });
  const title = t("activitiesSection.title");
  const activities = t("activitiesSection.activities", { returnObjects: true });
  const inclusions = t("details.inclusionsList", { returnObjects: true });
  const exclusions = t("details.exclusionsList", { returnObjects: true });
  const plannerData = t("details.planner", { returnObjects: true });

  return (
    <div className="package">

      {/* HERO SECTION */}
      <section className="package-hero">
        <img src="/images/mara.jpg" alt="Osiligi Reserve" className="hero-image" />
        <div className="phero-overlay" />
        <div className="phero-text">
          <h1>{t('wildebeestPage.title')}</h1>
          <p><b>{t('wildebeestPage.duration')}</b></p>
          <p>{t('wildebeestPage.subtitle')}</p>
        </div>
      </section>

      {/* INTRO */}
      <section className="package-intro">
        <div className="package-intro-content">
          <h2>{t('wildebeestPage.intro.heading')}</h2>
          <p>{t('wildebeestPage.intro.paragraph1')}</p>
          <p>{t('wildebeestPage.intro.paragraph2')}</p>
        </div>
      </section>

      {/* CAROUSELS */}
      <section className="package-carousel-wrapper">
        {/* First carousel */}
        <div className="carousel-container">
          <div className="carousel-wrapper">
            <Slider {...sliderSettings}>
              <div><img src="/images/ELPHATIN3.JPG" alt="Mara Gallery 1" className="carousel-image" loading="lazy" /></div>
              <div><img src="/images/ffleetmuddy.jpeg" alt="Mara Gallery 2" className="carousel-image" loading="lazy" /></div>
              <div><img src="/images/ZEBRA ATTACK.jpg" alt="Mara Gallery 3" className="carousel-image" loading="lazy" /></div>
            </Slider>
          </div>
        </div>

        {/* Second carousel - hidden on mobile */}
        <div className="carousel-container hide-on-mobile">
          <div className="carousel-wrapper">
            <Slider {...sliderSettings}>
              <div><img src="/images/prey.JPG" alt="Mara Gallery 4" className="carousel-image" loading="lazy" /></div>
              <div><img src="/images/cheetah.jpg" alt="Mara Gallery 5" className="carousel-image" loading="lazy" /></div>
              <div><img src="/images/cubswatering.jpg" alt="Mara Gallery 6" className="carousel-image" loading="lazy" /></div>
            </Slider>
          </div>
        </div>
      </section>

      {/* ACTIVITIES */}
      <section className="activities-section">
        <div className="activities container">
          <h2 className="activities-title">{title}</h2>
          <div className="activities-card layout-split">
            <ul className="activities-list">
              {activities.map((item, idx) => (
                <li key={idx}>
                  <strong>{item.title}</strong> — {item.description}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* ITINERARY */}
      <section className="package-itinerary">
        <h2><FaMapMarkedAlt /> Program / Itinerary</h2>
        <div className="accordion-wrapper">
          {itineraryData.map((item, i) => (
            <DayAccordion
              key={i}
              item={{ ...item, icon: itineraryIcons[i], image: itineraryImages[i] }}
              isOpen={openDay === i}
              onClick={() => toggle(i)}
            />
          ))}
        </div>
      </section>

      {/* ACCOMMODATION */}
     <div className='accomodation-card'>
  {/* On Budget Card */}
  <h5>{t('accommodation.onBudgetTitle')}</h5>
  <div className='onBudget-card'>
    <div className='charge-section'>
      <table>
        <thead>
          <tr>
            <th>{t('accommodation.table.months')}</th>
            <th>{t('accommodation.table.onePerson')}</th>
            <th>{t('accommodation.table.twoToThree')}</th>
            <th>{t('accommodation.table.fourToSix')}</th>
            <th>{t('accommodation.table.sevenPlus')}</th>
            <th>{t('accommodation.table.youngAdult')}</th>
            <th>{t('accommodation.table.child')}</th>
          </tr>
        </thead>
        <tbody>
          {t('accommodation.onBudgetRows', { returnObjects: true }).map((row, index) => (
            <tr key={index}>
              <td>{row.months}</td>
              <td>{row.onePerson}</td>
              <td>{row.twoToThree}</td>
              <td>{row.fourToSix}</td>
              <td>{row.sevenPlus}</td>
              <td>{row.youngAdult}</td>
              <td>{row.child}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div className='accomodationImg-card'>
      <img src="/images/oseki.jpeg" alt={t('accommodation.luxuryAlt')} />
    </div>
  </div>

  {/* Luxury Tented Camp */}
  <h5>{t('accommodation.luxuryTitle')}</h5>
  <div className='luxury-card'>
    <div className='accomodationImg-card'>
       <img src="/images/Accommodation-1.jpg" alt={t('accommodation.luxuryAlt')} />
    </div>
    <div className='charge-section'>
      <table>
        <thead>
          <tr>
            <th>{t('accommodation.table.months')}</th>
            <th>{t('accommodation.table.onePerson')}</th>
            <th>{t('accommodation.table.twoToThree')}</th>
            <th>{t('accommodation.table.fourToSix')}</th>
            <th>{t('accommodation.table.sevenPlus')}</th>
            <th>{t('accommodation.table.youngAdult')}</th>
            <th>{t('accommodation.table.child')}</th>
          </tr>
        </thead>
        <tbody>
          {t('accommodation.luxuryRows', { returnObjects: true }).map((row, index) => (
            <tr key={index}>
              <td>{row.months}</td>
              <td>{row.onePerson}</td>
              <td>{row.twoToThree}</td>
              <td>{row.fourToSix}</td>
              <td>{row.sevenPlus}</td>
              <td>{row.youngAdult}</td>
              <td>{row.child}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>

  <p className='volnote'>
    <b>{t('accommodation.noteLabel')}</b> {t('accommodation.noteText')}
  </p>
</div>

      {/* INCLUSIONS / EXCLUSIONS */}
      <section className="package-details-wrapper">
        <div className="left-section">
          <div className="card-container">
            {activeTab === "inclusions" ? (
              <div className="inclusions-card">
                <div className="tab-buttons">
                  <button className={activeTab === "inclusions" ? "active" : ""} onClick={() => setActiveTab("inclusions")}>
                    {t("details.tabs.inclusions")}
                  </button>
                  <button className={activeTab === "exclusions" ? "active" : ""} onClick={() => setActiveTab("exclusions")}>
                    {t("details.tabs.exclusions")}
                  </button>
                </div>
                <br />
                <h3>{t("details.tabs.inclusions")}</h3>
                <ul className="inclusions-list">
                  {inclusions.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
              </div>
            ) : (
              <div className="exclusions-card">
                <div className="tab-buttons">
                  <button onClick={() => setActiveTab("inclusions")}>{t("details.tabs.inclusions")}</button>
                  <button className={activeTab === "exclusions" ? "active" : ""} onClick={() => setActiveTab("exclusions")}>
                    {t("details.tabs.exclusions")}
                  </button>
                </div>
                <br />
                <h3>{t("details.tabs.exclusions")}</h3>
                <ul className="exclusions-list">
                  {exclusions.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div className="planner-info">
          <img src="/images/Kikanae.jpeg" alt={plannerData.imageAlt} />
          <h4>{plannerData.name}</h4>
          <p>{plannerData.role}</p>
          <p>
            {plannerData.phoneLabel}: <a href={`tel:${plannerData.phoneNumber}`}>{plannerData.phoneNumber}</a>
          </p>
          <p>
            {plannerData.emailLabel}: <a href={`mailto:${plannerData.emailAddress}`}>{plannerData.emailAddress}</a>
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="place-cta" aria-label="Call to Action Section">
        <h2>{t("cta.heading")}</h2>
        <p>{t("cta.text")}</p>
        <Link to={t("cta.buttonLink")} className="book-now">{t("cta.button")}</Link>
      </section>
    </div>
  );
};

export default Packagemara;
